import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/orders/`;

export const orders = {
  get: () => generateApiPath(pathBase),
};
